/**
 * @typedef {object} SignedDocumentExt
 * @property {'document'} type Document type indicator
 * @property {boolean} completed Indicated whether the document is being fully signed
 * @property {Array.<SigneeResource>} signeesCompleted Returns the list of signees who signed the document
 * @property {number} progress The percentage of persons who signed the document
 * 
 * @typedef {SignedDocumentResource & SignedDocumentExt} SignedDocument
 */
angular.module('access.Nodes')
    .constant('EsignatureStatus', {
        INITIATED: 'initiated',
        WAITING: 'waiting',
        SIGNED: 'signed',
        NOTARIZED: 'notarized',
        TERMINATED: 'terminated'
    })
    .factory('EsignatureDocumentInterceptor', ['$filter', '$translate', 'EsignatureStatus', function ($filter, $translate, EsignatureStatus) {
        return {
            response: function (res) {
                if (angular.isArray(res.resource)) {
                    return res.resource.map(EsignatureDocumentDecorator);
                } else {
                    return EsignatureDocumentDecorator(res.resource);
                }
            }
        };

        /**
         * Decorate Signed document with additional methods
         * @param {SignedDocumentResource} item 
         * @returns {SignedDocument}
         */
        function EsignatureDocumentDecorator(item) {
            Object.defineProperties(item, {
                type: {
                    value: 'document'
                },
                completed: {
                    /** @this SignedDocumentResource */
                    get: function () {

                        return this.status === EsignatureStatus.SIGNED || this.status === EsignatureStatus.NOTARIZED;
                    }
                },
                signeesCompleted: {
                    /** @this SignedDocumentResource */
                    get: function () {
                        return this.signees.filter(function (signee) {
                            return signee.signed_at != null;
                        });
                    }
                },
                progress: {
                    /** @this SignedDocument */
                    get: function () {
                        return Math.max(Math.round(this.signeesCompleted.length / this.signees.length * 100), 3.75);
                    }
                },
                isSigned: {
                    /** @this SignedDocumentResource */
                    get: function () {
                        return this.status === EsignatureStatus.SIGNED || this.status === EsignatureStatus.NOTARIZED;
                    }
                },
                isNotarized: {
                    /** @this SignedDocumentResource */
                    get: function () {
                        return this.status === EsignatureStatus.NOTARIZED;
                    }
                },
                isWaiting: {
                    /** @this SignedDocumentResource */
                    get: function () {
                        return this.status === EsignatureStatus.WAITING;
                    }
                },
                canShowDetails: {
                    get: function () {
                        return this.permissions['can_show_details'];
                    }
                },
                canBeSigned: {
                  get: function () {
                      return this.isSequentialSignature && this.permissions['can_be_signed'];
                  }
                },
                canBeDeleted: {
                    get: function () {
                        return this.permissions['can_be_deleted'];
                    }
                },
                canBeShared: {
                    get: function () {
                        return this.permissions['can_be_shared'];
                    }
                },
                getSigneeStatus: {
                    value: function (signee) {
                        if (signee.signed_at) {
                            return $filter('formattedLocalDate')(signee.signed_at);
                        }

                        if (!signee.send_order) {
                            return '';
                        }

                        return $translate.instant(
                            this.isDueSignee(signee) ?
                                'esignature_details_dialog_signee_in_progress_status' :
                                'esignature_details_dialog_signee_pending_status'
                        );
                    }
                },
                isSequentialSignature: {
                    get: function () {
                        return !!this.signees[0].send_order;
                    }
                },
                signFileUrl: {
                    get: function () {
                        return $filter('apiAddress')(`/sync_and_share_nodes/${this.node_uuid}/esignatures/${this.uuid}/sign_file_page_url`);
                    }
                },
                dueSignee: {
                    value: item.signees
                        .sort((signee1, signee2) => (signee1.send_order > signee2.send_order) ? 1 : -1)
                        .find(({ signed_at }) => signed_at == null)
                },
                isDueSignee: {
                    value: function (signee) {
                        return this.dueSignee === signee;
                    }
                }
            });

            return item;
        }
    }]);
